import CacheService from './cache-service'
import Singleton from './singleton'

export default class ApiConnector extends Singleton {
  constructor (singleton, baseUri, http) {
    super(singleton)

    if (typeof baseUri !== 'string') {
      throw new TypeError(`Base uri has to be string. Typeof ${typeof baseUri} given.`)
    }

    this.baseUri = baseUri
    this.cache = CacheService.getInstance()
    this.http = http
  }

  __parseError (err) {
    const d = err.response.data
    return d.errors ? { failed: true, errors: d.errors } : []
  }

  async _get (uri, params = {}) {
    try {
      if (!this.cache.has(uri)) {
        const res = await this.http.get(`${this.baseUri}/api/${uri}`, {
          params: params
        })
        this.cache.set(uri, res.data.data)
      }

      return this.cache.get(uri, [])
    } catch (e) {
      return this.__parseError(e)
    }
  }

  async _post (uri, body) {
    try {
      const res = await this.http.post(`${this.baseUri}/api/${uri}`, body)

      return res.data.data
    } catch (e) {
      return this.__parseError(e)
    }
  }

  async createReservation (garage, body, cb) {
    const data = await this._post(`garages/${garage}/leads`, body)
    return cb(data)
  }

  async getGarages (countryCode ,cb) {
    const data = await this._get('garages', { country_code: countryCode })
    return cb(data)
  }

  async getGarage (id, cb) {
    const data = await this._get(`garages/${id}`)
    return cb(data)
  }

  async getRegions (countryCode, cb) {
    const data = await this._get(`dictionaries/countries/${countryCode}/regions`)
    return cb(data)
  }

  async getServices (countryCode, cb) {
    const data = await this._get('tags', { type: 'garage_service', country_code: countryCode })
    return cb(data)
  }
}
